import { DecimalPipe, NgFor, NgIf } from '@angular/common';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { MaskitoDirective } from '@maskito/angular';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { Component, OnInit } from '@angular/core';
import { MaxTenDirective } from '../../directives/max-ten.directive';
import { NotEmptyInteger } from '../../directives/not-empty.directive';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NoLeftZeroDirective } from '../../directives/no-left-zero.directive';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { PQRAlimentacaoEscolarDto } from '../../dtos/pqr-alimentacao-escolar.dto';
import {
  AcessoOfertaEducacionalStateService,
  CondicaoQualidadeStateService,
  EtapasDeEdicaoService, LocalizacaoService, MemoriaDeCalculoService
} from "../../services";
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { MenuSuspensoComponent } from '../../shared/menu-suspenso/menu-suspenso.component';
import {
  IconeAtivo,
  LayoutEditorContentService,
} from '../../layouts/layout-editor/layout-editor-content.service';
import { DialogPqrAlimentacaoEscolarComponent } from '../../shared/dialog-pqr-alimentacao-escolar/dialog-pqr-alimentacao-escolar.component';
import { mask_dinheiro, mask_mes_ano } from '../../directives/mascaras';
import {
  caminhoImagemLateralCondicaoQualidade,
  corFundoLateralCondicaoQualidade,
  opcoesMenuLateralAtivas,
  opcoesMenuLateralInativas,
  tituloMenuLateralCondicaoQualidade,
} from '../../layouts/layout-editor/template/lateral-navegacao-condicao-qualidade';
import { ModalInconsistenciaComponent } from '../../shared/modal-inconsistencia/modal-inconsistencia.component';
import { Observable } from 'rxjs';
import { MemoriaDeCalculoDto, TipoTurnoDto } from "../../dtos";
import { EtapaEnsinoDto } from '../../dtos/etapa-ensino-dto';
import { PtBrNumberDirective } from '../../directives/pt-br-number.directive';
import { BasePqrComponent } from '../base-pqr/base-pqr.component';
import { ValidadorTela } from '../../interfaces/validacao.interface';
import { TipoSimulacao } from "../../enums/simulation-type.enum";

export interface PQRAlimentacaoEscolarTableCell {
  codPqrAlimentacaoEscolar: number;
  numeroDiasLetivosAno: number;
  valorRefeicao: number;
  valorRefeicaoIndigenaQuilombola: number;
  tipoTurno: TipoTurnoDto;
  etapaEnsino: EtapaEnsinoDto;
}

export interface PQRNumeroMatriculasAlimentacaoTableCell {
  etapa: string;
  parcial: number;
  integral?: number;
  parcialIndigena: number;
  integralIndigena?: number;
}

@Component({
  selector: 'app-alimentacao-escolar',
  standalone: true,
  imports: [
    NgFor,
    FormsModule,
    MatIconModule,
    TabelaComponent,
    NotEmptyInteger,
    MaxTenDirective,
    MatTooltipModule,
    MaskitoDirective,
    NoLeftZeroDirective,
    OnlyNumbersDirective,
    MenuSuspensoComponent,
    DialogPqrAlimentacaoEscolarComponent,
    DecimalPipe,
    PtBrNumberDirective,
    NgIf,
  ],
  templateUrl: './alimentacao-escolar.component.html',
  styleUrl: './alimentacao-escolar.component.scss',
})
export class AlimentacaoEscolarComponent extends BasePqrComponent<PQRAlimentacaoEscolarDto> implements OnInit, ValidadorTela {

  protected valoresPadrao: PQRAlimentacaoEscolarDto[] = [];
  protected valoresEdicao: PQRAlimentacaoEscolarDto[] = [];

  mask_dinheiro = mask_dinheiro;
  mask_mes_ano = mask_mes_ano;

  mostrarInconsistencia: boolean = false;
  usuarioQuerSair: boolean = false;

  dadosTabela: PQRAlimentacaoEscolarTableCell[] = [];
  dadosMatriculaTabela: PQRNumeroMatriculasAlimentacaoTableCell[] = [];
  numeroMatriculasEdicao: any[] = [];
  resultadoMemoriaCalculo!: MemoriaDeCalculoDto

  constructor(
    router: Router,
    toastr: ToastrService,
    private dialog: MatDialog,
    dialogRestaurarValores: MatDialog,
    private dialogPqrAlimentacaoEscolar: MatDialog,
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private layoutEditorContentService: LayoutEditorContentService,
    private condicaoQualidadeStateService: CondicaoQualidadeStateService,
    private acessoOfertaEducacionalStateService: AcessoOfertaEducacionalStateService,
    private memoriaCalculoService: MemoriaDeCalculoService,
    private localizacaoService: LocalizacaoService,
    private featureFlagService: FeatureFlagService,
  ) {
    super(router, toastr, dialogRestaurarValores, dialogPqrAlimentacaoEscolar);
    this.layoutEditorContentService.definirIconeAtivo(IconeAtivo.QUALIDADE);
    this.layoutEditorContentService.definirTituloMenuLateral(
      tituloMenuLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definirOpcoesAtivas(
      opcoesMenuLateralAtivas,
    );
    this.layoutEditorContentService.definirOpcoesInativas(
      opcoesMenuLateralInativas,
    );
    this.layoutEditorContentService.definirCaminhoImagem(
      caminhoImagemLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definirCorFundoMenuLateral(
      corFundoLateralCondicaoQualidade,
    );
    this.layoutEditorContentService.definiOpcaoAtivaSelecionada(8);
    this.layoutEditorContentService.definirExibirBotaoAnterior(true);
    this.layoutEditorContentService.definirRotaAnterior(
      '/relatorio2/condicao-qualidade/manutencao-das-escolas',
    );
    this.layoutEditorContentService.definirExibirBotaoProximo(true);
    this.layoutEditorContentService.definirRotaProximo(
      '/relatorio2/condicao-qualidade/fator-ponderacao',
    );
  }

  async ngOnInit() {
    this.etapasDeEdicaoService.setOpcaoAtual(15);
    this.carregarDadosInterno();
    await this.carregarDadosMatriculasTabela();
  }

  private carregarDadosInterno() {
    this.carregarDados(
      () => this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarPadrao(),
      () => this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarValores()
    );
    this.processarDadosTabela(this.valoresEdicao);
  }

  async carregarDadosMatriculasTabela() {
    const localizacaoSelecionada = this.localizacaoService.obterLocalizacaoSelecionada();

    const temMatriculasEditadas = this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculasValores().length > 0;

    if (!temMatriculasEditadas &&
      (localizacaoSelecionada?.tipoSimulacaoSelecionado === TipoSimulacao.planejamentoNacional ||
        localizacaoSelecionada?.tipoSimulacaoSelecionado === TipoSimulacao.planejamentoPorEsferaAdmEstadual ||
        localizacaoSelecionada?.tipoSimulacaoSelecionado === TipoSimulacao.planejamentoPorEsferaAdmMunicipal ||
        (localizacaoSelecionada?.tipoSimulacaoSelecionado === TipoSimulacao.planejamento && localizacaoSelecionada.cidadeSelecionada == null))) {

      this.resultadoMemoriaCalculo = await this.memoriaCalculoService.buscarMemoriaDeCalculoLocalizacao();
      const numeroMatriculas = this.resultadoMemoriaCalculo.resultadoMatriculasAlimentacao!;

      this.dadosMatriculaTabela = [
        {
          etapa: 'Creche',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoCrecheParcial,
          integral: numeroMatriculas?.resultadoMatriculasAlimentacaoCrecheIntegral,
          parcialIndigena: numeroMatriculas?.resultadoMatriculasAlimentacaoIndigenaCrecheParcial,
          integralIndigena: numeroMatriculas?.resultadoMatriculasAlimentacaoIndigenaCrecheIntegral,
        },
        {
          etapa: 'Pré-Escola',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoPreEscolaParcial,
          integral: numeroMatriculas?.resultadoMatriculasAlimentacaoPreEscolaIntegral,
          parcialIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaPreEscolaParcial,
          integralIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaPreEscolaIntegral,
        },
        {
          etapa: 'Ensino Fundamental - Anos Iniciais',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsFundAnosIniciaisParcial,
          integral: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsFundAnosIniciaisIntegral,
          parcialIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsFundAnosIniciaisParcial,
          integralIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsFundAnosIniciaisIntegral,
        },
        {
          etapa: 'Ensino Fundamental - Anos Finais',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsFundAnosFinaisParcial,
          integral: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsFundAnosFinaisIntegral,
          parcialIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsFundAnosFinaisParcial,
          integralIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsFundAnosFinaisIntegral,
        },
        {
          etapa: 'Ensino Médio',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsMedioParcial,
          integral: numeroMatriculas?.resultadoMatriculasAlimentacaoEnsMedioIntegral,
          parcialIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsMedioParcial,
          integralIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEnsMedioIntegral,
        },
        {
          etapa: 'Educação de Jovens e Adultos (EJA)',
          parcial: numeroMatriculas?.resultadoMatriculasAlimentacaoEjaParcial,
          parcialIndigena: numeroMatriculas.resultadoMatriculasAlimentacaoIndigenaEjaParcial,
        }
      ];

    } else {
      this.preencherTabelaOfertaDetalhada();

      this.dadosMatriculaTabela = [
        {
          etapa: 'Creche',
          parcial: this.numeroMatriculasEdicao[0].total,
          integral: this.numeroMatriculasEdicao[0].tempoIntegral,
          parcialIndigena: this.numeroMatriculasEdicao[0].totalIndigenaQuilombola,
          integralIndigena: this.numeroMatriculasEdicao[0].tempoIntegralIndigenaQuilombola,
        },
        {
          etapa: 'Pré-Escola',
          parcial: this.numeroMatriculasEdicao[1].total,
          integral: this.numeroMatriculasEdicao[1].tempoIntegral,
          parcialIndigena: this.numeroMatriculasEdicao[1].totalIndigenaQuilombola,
          integralIndigena: this.numeroMatriculasEdicao[1].tempoIntegralIndigenaQuilombola,
        },
        {
          etapa: 'Ensino Fundamental - Anos Iniciais',
          parcial: this.numeroMatriculasEdicao[2].total,
          integral: this.numeroMatriculasEdicao[2].tempoIntegral,
          parcialIndigena: this.numeroMatriculasEdicao[2].totalIndigenaQuilombola,
          integralIndigena: this.numeroMatriculasEdicao[2].tempoIntegralIndigenaQuilombola,
        },
        {
          etapa: 'Ensino Fundamental - Anos Finais',
          parcial: this.numeroMatriculasEdicao[3].total,
          integral: this.numeroMatriculasEdicao[3].tempoIntegral,
          parcialIndigena: this.numeroMatriculasEdicao[3].totalIndigenaQuilombola,
          integralIndigena: this.numeroMatriculasEdicao[3].tempoIntegralIndigenaQuilombola,
        },
        {
          etapa: 'Ensino Médio',
          parcial: this.numeroMatriculasEdicao[4].total,
          integral: this.numeroMatriculasEdicao[4].tempoIntegral,
          parcialIndigena: this.numeroMatriculasEdicao[4].totalIndigenaQuilombola,
          integralIndigena: this.numeroMatriculasEdicao[4].tempoIntegralIndigenaQuilombola,
        },
        {
          etapa: 'Educação de Jovens e Adultos (EJA)',
          parcial: this.numeroMatriculasEdicao[5].total,
          parcialIndigena: this.numeroMatriculasEdicao[5].totalIndigenaQuilombola,
        }
      ];
    }
  }

  preencherTabelaOfertaDetalhada(): void {
    const projecoes = this.acessoOfertaEducacionalStateService.getProjecoesOfertaMatriculasValores();
    const etapas = [
      { etapa: 'Creche', codigo: [1], isGrupo: true },
      { etapa: 'Pré-escola', codigo: [2], isGrupo: true },
      { etapa: 'Ensino Fundamental – anos iniciais', codigo: [3], isGrupo: true },
      { etapa: 'Ensino Fundamental – anos finais', codigo: [4], isGrupo: true },
      { etapa: 'Ensino médio', codigo: [5], isGrupo: true },
      { etapa: 'EJA', codigo: [6], isGrupo: true },
    ];
    const linhas = etapas.map(etapa => {
      let diurno = 0, tempoIntegral = 0, noturno = 0, diurnoIndigenaQuilombola = 0, tempoIntegralIndigenaQuilombola = 0, noturnoIndigenaQuilombola = 0;
      projecoes.forEach(projecao => {
        projecao.etapasEnsino.forEach(matricula => {
          if (etapa.codigo.includes(matricula.codEtapaEnsino)) {
            if (projecao.localizacaoDiferenciada == 2 || projecao.localizacaoDiferenciada == 3) {
              diurnoIndigenaQuilombola += matricula.numeroMatriculasDiurno || 0;
              tempoIntegralIndigenaQuilombola += matricula.numeroMatriculasIntegral || 0;
              noturnoIndigenaQuilombola += matricula.numeroMatriculasNoturno || 0;
            }
            else {
              diurno += matricula.numeroMatriculasDiurno || 0;
              tempoIntegral += matricula.numeroMatriculasIntegral || 0;
              noturno += matricula.numeroMatriculasNoturno || 0;
            }
          }
        });
      });
      const total = diurno + noturno;
      const totalIndigenaQuilombola = diurnoIndigenaQuilombola + noturnoIndigenaQuilombola;
      return {
        etapa: etapa.etapa,
        total,
        totalIndigenaQuilombola,
        diurno,
        tempoIntegral,
        noturno,
        diurnoIndigenaQuilombola,
        tempoIntegralIndigenaQuilombola,
        noturnoIndigenaQuilombola,
        isGrupo: etapa.isGrupo
      };
    });

    this.numeroMatriculasEdicao = [
      ...linhas
    ];
  }

  private processarDadosTabela(dados: PQRAlimentacaoEscolarDto[]): void {
    this.dadosTabela = dados.map((item: PQRAlimentacaoEscolarDto) => {
      return {
        codPqrAlimentacaoEscolar: item.codPqrAlimentacaoEscolar,
        numeroDiasLetivosAno: item.numeroDiasLetivos,
        valorRefeicao: item.valorRefeicao,
        valorRefeicaoIndigenaQuilombola: item.valorRefeicaoIndigenaQuilombola,
        tipoTurno: item.tipoTurno,
        etapaEnsino: item.etapaEnsino,
      };
    });
  }

  atualizarDadosDoServicoDeEstado(): void {
    const dados = this.dadosTabela.map(
      (item: PQRAlimentacaoEscolarTableCell) => {
        return {
          codPqrAlimentacaoEscolar: item.codPqrAlimentacaoEscolar,
          numeroDiasLetivos: item.numeroDiasLetivosAno,
          valorRefeicao: item.valorRefeicao,
          valorRefeicaoIndigenaQuilombola: item.valorRefeicaoIndigenaQuilombola,
          tipoTurno: item.tipoTurno,
          etapaEnsino: item.etapaEnsino,
        };
      },
    );

    this.valoresEdicao = dados;
    this.atualizarValores();
  }

  public override restaurarValoresPadrao(): void {
    super.restaurarValoresPadrao();
    this.processarDadosTabela(this.valoresEdicao);
  }

  protected atualizarValores() {
    this.condicaoQualidadeStateService.setPQRAlimentacaoEscolarValores(this.valoresEdicao);
  }

  protected openDialogPqrValoresPadrao(): void {
    const dialogRef = this.dialogPqrAlimentacaoEscolar.open(
      DialogPqrAlimentacaoEscolarComponent,
      {
        panelClass: 'dialog-pqr-alimentacao-escolar',
      },
    );

    dialogRef.componentInstance.dados =
      this.condicaoQualidadeStateService.getPQRAlimentacaoEscolarPadrao();
  }

  public criaMensagemInconsistencia(): string[] {
    return [];
  }

  abrirDialog(proximaRota: RouterStateSnapshot): void {
    this.toastr.error('Verifique as inconsistências.', 'Atenção!');

    const data = {
      mensagens: this.criaMensagemInconsistencia(),
      proximaRota: proximaRota.url,
    };

    const dialogRef = this.dialog.open(ModalInconsistenciaComponent, {
      data: data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'sim') {
        this.usuarioQuerSair = true;
        this.router.navigate([proximaRota.url]);
      }
    });
  }
}

export function canDeactivateFnAlimentacaoEscolar(
  component: AlimentacaoEscolarComponent,
  currentRoute: ActivatedRouteSnapshot,
  currentState: RouterStateSnapshot,
  nextState?: RouterStateSnapshot,
): Observable<boolean> | boolean {
  const mensagemInconsistencia: string[] = component.criaMensagemInconsistencia();
  if (
    mensagemInconsistencia.length > 0 &&
    !component.usuarioQuerSair
  ) {
    if (nextState) {
      component.abrirDialog(nextState);
    }
    component.mostrarInconsistencia = true;
    component.mensagensInconsistencia = mensagemInconsistencia;
    return false;
  }
  return true;
}
